import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import FullScreenDataContainer from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';

import SubscriptionSetupContent from './SubscriptionSetupContent';
import { useSubscriptionSetupContext } from './SubscriptionSetupContext';

const styles = () => ({
  root: {},
});

const SubscriptionSetupContainer = ({
  className,
  classes,
}) => {
  const { isInitializing } = useSubscriptionSetupContext();

  return (
    <FullScreenDataContainer
      className={classes.container}
      component={SubscriptionSetupContent}
      componentProps={{
        className: classNames(classes.root, className),
      }}
      loading={isInitializing}
    />
  );
};

SubscriptionSetupContainer.defaultProps = {
  className: '',
};

SubscriptionSetupContainer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SubscriptionSetupContainer);
